import { types, getEnv, flow, SnapshotOut } from 'mobx-state-tree';
import { IAppEnv } from '../appEnvironment';
import { IGroupedApiCtx, errorIsCancel, ICalendarEventsWithTs, ProgressStateModelForStore, ProgressStateModel, errorIsInApiRequest, protoUtils } from 'eTip--common';
import { ISportsBettingApi } from '../api/api';
import { CalendarEventStore } from './calendarEvent';
import { observable } from 'mobx';

export const UpcomigLiveEventsStoreKey = 'homeStore';
export const UpcomigLiveEventsStore = types
    .model(UpcomigLiveEventsStoreKey, {
        state: types.optional(ProgressStateModelForStore, ProgressStateModel.NotInitialized),
        timeStamp: types.maybeNull(types.number),
        events: types.maybeNull(types.array(CalendarEventStore)),
        eventsCount: types.maybeNull(types.number)
    })
    .actions(self => {
        const env = getEnv<IAppEnv>(self);
        let synchroCtxForUpcomingLiveEvents: IGroupedApiCtx<ISportsBettingApi> | null = null;

        const loadUpcomingLiveEventsAsync: (asFullLoad: boolean) => Promise<void> = flow(function* (asFullLoad: boolean) {
            let ctx: IGroupedApiCtx<ISportsBettingApi> | null = null;

            try {
                if (synchroCtxForUpcomingLiveEvents && synchroCtxForUpcomingLiveEvents.isOpen()) {
                    synchroCtxForUpcomingLiveEvents.cancel('Load has been canceled.');
                    synchroCtxForUpcomingLiveEvents = null;
                }

                if (asFullLoad) {
                    self.state = ProgressStateModel.Loading;
                    self.events = observable([]);
                }

                ctx = env.api.open();
                synchroCtxForUpcomingLiveEvents = ctx;
                const r: ICalendarEventsWithTs = yield ctx.api.getUpcomingLiveEventsAsync(self.timeStamp);
                setData(r);

                self.state = ProgressStateModel.Success;
            } catch (error) {
                if (errorIsCancel(error)) {
                    throw error;
                }
                if (asFullLoad || !errorIsInApiRequest(error)) {
                    self.state = ProgressStateModel.Failed;
                }
            } finally {
                if (synchroCtxForUpcomingLiveEvents === ctx) {
                    synchroCtxForUpcomingLiveEvents = null;
                }
            }
        });

        const setData = (apiData: ICalendarEventsWithTs): void => {
            self.events = observable([]);

            if (apiData) {
                self.timeStamp = apiData.Timestamp;
                self.eventsCount = apiData.Data.TotalCount;
                if (apiData.Data.Events) {
                    apiData.Data.Events.forEach(item => {
                        let store = CalendarEventStore.create(<SnapshotOut<typeof CalendarEventStore>>{
                            id: item.Id,
                            name: item.Name,
                            graphicsPresentationId: item.GraphicsPresentationId,
                            categoryPathName: item.Path,
                            isLive: item.IsLive,
                            time: protoUtils.protoTimeStamp2Date(item.Date).getTime(),
                            hasActivePrematch: false
                        });
                        self.events.push(store);
                    })
                }
            }

        }

        return {
            loadUpcomingLiveEventsAsync
        }
    });